import React, { useState } from 'react'
import data from '../../constant/data.json';
export default function AppFooter(props) {
    const [hoverId,setHoweId] = useState(0);
    const footer = [
        {
            id:1,
            name:"RESUME",
            sticker:"downloadnow.png",
            width:109,
            height:51,
            link:data.resume
        },
        {
            id:2,
            name:"Instagram",
            sticker:"travelstories.png",
            width:109,
            height:51,
            link:data.instagram
        },
        {
            id:3,
            name:"LInkedIN",
            sticker:"seriusme.png",
            width:81,
            height:51,
            link:data.linkedIn
        },
        {
            id:4,
            name:"GITHUB",
            // sticker:"forfun.png",
            sticker:"startfromhere.png",
            // width:61,
            // height:51,
            width:109,
            height:51,
            link:data.dribble
        },
        // {
        //     id:5,
        //     name:"BEhance",
        //     sticker:"startfromhere.png",
        //     width:109,
        //     height:51,
        //     link:data.behance
        // },
        {
            id:6,
            name:"YouTube",
            // sticker:"iwish.png",
            sticker:"forfun.png",
            // width:109,
            // height:51,
              width:61,
            height:51,
            link:data.behance
        },
    ]

    const onLinkClick = (item)=>{
        if(item.link){
            window.open(item.link, "_blank")
        }
    }

    return (
        <div className='footer-main'>
                {footer.map((item,index) =>{
                    return(
                        <div
                        onMouseEnter={()=>{
                            setHoweId(item.id);
                        }}
                        onMouseLeave={()=>{
                            setHoweId(0);
                        }}
                        onClick={()=> onLinkClick(item)}
                        
                        key={item.id} className='footer-item'>
                            <p className='footer-item-text'>{item.name}</p>
                            {hoverId === item.id?
                            <img 
                            style={{
                                width:item.width,
                                height:item.height,
                                rotate:index % 2 ? "20deg":"-20deg"
                            }}
                            src={require(`../../assets/images/${item.sticker}`)} className='footer-sticker-img' />:null}
                        </div>
                    )
                })}
        </div>
    )
}
